<app-table [config]="tableConfig"></app-table>
